module.exports = __webpack_public_path__ + "static/card4-ff145825290a7eca0edf586363846c98.png";